import { logger } from '#pplx/frontend/logger/browser.js';
const GEOLOCATION_REQUEST_OPTIONS = {
    enableHighAccuracy: true,
    // https://developer.mozilla.org/en-US/docs/Web/API/Geolocation_API/Using_the_Geolocation_API#the_geolocation_object
    timeout: 10_000,
    maximumAge: 0,
};
const GEOLOCATION_INVOCATION_ERROR = {
    code: 2,
    message: 'Geolocation API threw synchronously',
    PERMISSION_DENIED: 1,
    POSITION_UNAVAILABLE: 2,
    TIMEOUT: 3,
};
export const queryGeolocationPermission = () => {
    try {
        return navigator.permissions.query({ name: 'geolocation' });
    }
    catch (error) {
        logger.warn('Geolocation permission query failed', { error });
        return undefined;
    }
};
export const getCurrentPosition = (onSuccess, onError) => {
    try {
        navigator.geolocation.getCurrentPosition(onSuccess, onError, GEOLOCATION_REQUEST_OPTIONS);
    }
    catch (error) {
        logger.warn('Geolocation getCurrentPosition threw synchronously', { error });
        onError(GEOLOCATION_INVOCATION_ERROR);
    }
};
export const clearPermissionChangeHandler = (status, handler, isEventListener) => {
    try {
        if (isEventListener) {
            status.removeEventListener('change', handler);
            return;
        }
        status.onchange = null;
    }
    catch (error) {
        logger.warn('Permission listener cleanup failed', { error, isEventListener });
    }
};
export const listenForPermissionChange = (status, handler) => {
    try {
        if (typeof status.addEventListener === 'function') {
            status.addEventListener('change', handler);
            return () => clearPermissionChangeHandler(status, handler, true);
        }
    }
    catch (error) {
        logger.warn('Permission listener addEventListener failed; falling back to onchange', { error });
    }
    try {
        status.onchange = handler;
        return () => clearPermissionChangeHandler(status, handler, false);
    }
    catch (error) {
        logger.warn('Permission listener onchange assignment failed', { error });
        return () => { };
    }
};
//# sourceMappingURL=geolocation.js.map